function sdInitReveals() {
  const items = document.querySelectorAll('.sd-reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('sd-visible'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.sdDelay || 0;
          setTimeout(() => entry.target.classList.add('sd-visible'), Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  items.forEach((el) => observer.observe(el));
}

function sdInitGaleriaProducto() {
  const galerias = document.querySelectorAll('[data-sd-galeria]');
  galerias.forEach((galeria) => {
    const principal = galeria.querySelector('[data-sd-imagen-principal]');
    const miniaturas = galeria.querySelectorAll('[data-sd-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach((btn) => {
      btn.addEventListener('click', () => {
        const src = btn.dataset.sdSrc;
        const srcset = btn.dataset.sdSrcset;
        if (!src) return;
        principal.src = src;
        if (srcset) principal.srcset = srcset;
        miniaturas.forEach((m) => m.classList.remove('is-activa'));
        btn.classList.add('is-activa');
      });
    });
  });
}

function sdInitVariantes() {
  const formularios = document.querySelectorAll('.sd-form');
  formularios.forEach((form) => {
    const datosEl = form.querySelector('[data-sd-variantes-json]');
    if (!datosEl) return;
    let variantes = [];
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }
    const selectores = form.querySelectorAll('[data-sd-opcion]');
    const inputId = form.querySelector('[data-sd-input-id]');
    const precioEl = form.querySelector('[data-sd-precio]');
    const precioAntesEl = form.querySelector('[data-sd-precio-antes]');
    const botonComprar = form.querySelector('[data-sd-boton-comprar]');
    const stockEl = form.querySelector('[data-sd-stock]');

    function opcionesSeleccionadas() {
      return Array.from(selectores).map((grupo) => {
        const activo = grupo.querySelector('.is-seleccionada');
        return activo ? activo.dataset.sdValor : null;
      });
    }

    function formatearDinero(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR',
      });
    }

    function actualizar() {
      const seleccion = opcionesSeleccionadas();
      const variante = variantes.find((v) => v.options.every((op, i) => op === seleccion[i]));

      selectores.forEach((grupo, grupoIndex) => {
        grupo.querySelectorAll('[data-sd-valor]').forEach((valorBtn) => {
          const valorSeleccion = [...seleccion];
          valorSeleccion[grupoIndex] = valorBtn.dataset.sdValor;
          const existe = variantes.some((v) => v.options.every((op, i) => {
            if (valorSeleccion[i] === null) return true;
            return op === valorSeleccion[i];
          }));
          valorBtn.disabled = !existe;
        });
      });

      if (!variante) return;

      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatearDinero(variante.price);
      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatearDinero(variante.compare_at_price);
          precioAntesEl.hidden = false;
        } else {
          precioAntesEl.hidden = true;
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.available;
        botonComprar.textContent = variante.available
          ? botonComprar.dataset.sdTextoDisponible
          : botonComprar.dataset.sdTextoAgotado;
      }
      if (stockEl) {
        stockEl.hidden = variante.available;
      }
    }

    selectores.forEach((grupo) => {
      grupo.querySelectorAll('[data-sd-valor]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          grupo.querySelectorAll('[data-sd-valor]').forEach((b) => b.classList.remove('is-seleccionada'));
          btn.classList.add('is-seleccionada');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.sdScriptsInitialized) return;
  window.sdScriptsInitialized = true;
  sdInitReveals();
  sdInitGaleriaProducto();
  sdInitVariantes();
});
